import React from 'react';
import { FormViewerContext } from '@wix/form-viewer/widget';
import { useEnvironment, WidgetProps } from '@wix/yoshi-flow-editor';
import { PagesContext } from '../../../contexts/PagesContext';
import BreakpointsProvider from '../../../hooks/BreakpointsProvider';
import { PlanCustomizationProps } from '../types';
import ProductPageWidget from './PlanCustomizationWidget';

const BREAKPOINTS = {
  isNarrow: (width: number) => width > 0 && width <= 750,
  isExtraNarrow: (width: number) => width > 0 && width <= 450,
};

export interface RootProductPageProps extends PlanCustomizationProps {
  locale: string;
}

export default function ({ host, locale, ...props }: WidgetProps<RootProductPageProps>) {
  const { isMobile } = useEnvironment();
  const width = host.dimensions.width ?? (isMobile ? 320 : 980);

  return (
    <PagesContext locale={locale}>
      <BreakpointsProvider breakpoints={BREAKPOINTS} defaultWidth={width}>
        <FormViewerContext host={host} {...props}>
          <ProductPageWidget {...props} />
        </FormViewerContext>
      </BreakpointsProvider>
    </PagesContext>
  );
}
